import { Slider } from "@/components/ui/slider"
import { ClockIcon, InfoIcon, LogOut, User, AlertTriangle } from "lucide-react"
import { useCalculator } from "@/contexts/CalculatorContext"
import { useAuth } from "@/contexts/AuthContext"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

export function Header() {
  const { mdsPerMonth, setMdsPerMonth } = useCalculator()
  const { user, signOut } = useAuth()
  
  // Show Exception menu item only for specific user
  const showExceptionMenu = user?.email === 'tomas.topinka@tipit.cz'

  const handleLogoDoubleClick = (e: React.MouseEvent) => {
    e.preventDefault() // Prevent default double-click behavior
    console.log('Logo double-clicked');
    throw new Error('Logo double-clicked');
  }

  const handleExceptionTest = () => {
      // Intentionally cause an error for Sentry testing
      throw new Error('Test exception from menu - Sentry testing')
  }

  return (
    <header className="border-b bg-white">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center mb-3">
          <h1 className="text-2xl font-bold">
            Kalkulačka provizí
          </h1>
          <div className="flex items-center gap-4">
            <DropdownMenu>
              <DropdownMenuTrigger className="flex items-center gap-2 hover:opacity-80">
                {user?.picture ? (
                  <img 
                    src={user.picture} 
                    alt={user.name} 
                    className="w-8 h-8 rounded-full"
                  />
                ) : (
                  <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                    <User className="w-4 h-4 text-primary" />
                  </div>
                )}
                <div className="text-sm text-right">
                  <div className="font-medium">{user?.name}</div>
                  <div className="text-muted-foreground text-xs">{user?.email}</div>
                </div>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                {showExceptionMenu && (
                  <DropdownMenuItem onClick={handleExceptionTest} className="text-orange-600">
                    <AlertTriangle className="mr-2 h-4 w-4" />
                    <span>Exception</span>
                  </DropdownMenuItem>
                )}
                <DropdownMenuItem onClick={signOut} className="text-red-600">
                  <LogOut className="mr-2 h-4 w-4" />
                  <span>Odhlásit se</span>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
            <img 
              src="/tipit-logo.svg" 
              alt="TipIT Logo" 
              className="h-12"
              onDoubleClick={handleLogoDoubleClick}
            />
          </div>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <ClockIcon className="w-4 h-4 text-primary" />
              <span className="text-sm font-medium">MDs za měsíc:</span>
            </div>
            <div className="flex items-center gap-4">
              <Slider
                value={[mdsPerMonth]}
                onValueChange={(values) => setMdsPerMonth(values[0])}
                min={16}
                max={21}
                step={1}
                className="w-[120px]"
              />
              <div className="text-sm min-w-[100px]">
                <span className="font-medium">{mdsPerMonth}</span>
                <span className="text-muted-foreground"> MDs/měsíc</span>
              </div>
            </div>
          </div>

          <div className="text-sm text-muted-foreground">
            (ročně: {mdsPerMonth * 12} MDs)
          </div>

          <div className="flex items-center gap-1 text-sm text-muted-foreground">
            <InfoIcon className="w-4 h-4 inline-flex" />
            <span>(Kalkulačka uvažuje, že konzultant zůstane 36 měsíců)</span>
          </div>
        </div>
      </div>
    </header>
  )
}